export default __webpack_public_path__ + "static/cover8-6a5d61e818ba367d6cd9e58853a29ba7.png";